
import { computed, defineComponent, PropType } from 'vue'
import { useI18n } from 'vue-i18n'
import CmTag from '@/views/dashboard/_components/cm-tag.vue'
import CmSvgIcon from '@/components/cm-svg-icon/cm-svg-icon.vue'
import {
  SafetyTagType,
  SafetyTagTypeColor,
  SafetyTagTypeIcon, SafetyTagTypeReverse, TagWithLevel, TagShow, ThreatTagIcon, PropsTag
} from '@/components/safety-tags/safety-tags.service'
import { ThreatLevel, ThreatLevelColor, resolveThreatLevelColor } from '@/enum/threat-level'
import { getOpacityColor, getType } from '@/utils/tool'
import { AttackType } from '@/enum/attack-type'
import { THREAT_TAG } from '@/services/threat-tag.service'

export default defineComponent({
  components: { CmTag, CmSvgIcon },

  props: {
    data: {
      type: [Array, Object, String] as PropType<PropsTag>,
      default: () => []
    },
    max: {
      type: Number,
      default: Infinity
    },
    empty: {
      type: String,
      default: '--'
    },
    type: {
      type: String,
      default: '',
    }
  },

  setup (props, context) {
    const { t, locale } = useI18n()

    const tagSHow = computed<TagShow[]>(() => {
      void locale.value
      let tagList = props.data
      if (!props.data) {
        tagList = []
      } else if (getType(props.data) !== 'array') {
        tagList = [props.data]
      }
      return formatTags(tagList)
    })

    function formatTags (tags: TagWithLevel[] | String[]) {
      return tags.map(v => {
        let result = {} as TagShow

        if (typeof v === 'string') {
          result.name = v
          result.type = props.type
        } else {
          result = v
        }

        const threatMeta = THREAT_TAG[result.name]
        if (threatMeta) {
          result = {
            ...result,
            level: threatMeta.level,
            attackType: threatMeta.attackType,
            title: t(threatMeta.titleI18nKey),
            describe: t(threatMeta.describeI18nKey),
          }
        } else {
          result.level = v.level || ThreatLevel.unknown
          result.title = result.name
          result.attackType = AttackType.unknown
          result.describe = result.name
        }

        result.type = result.type || SafetyTagType.unknown
        result = { ...result, ...getTagStyle(result) }
        return result
      })
    }

    function geTooltipContent () {
      return tagSHow.value
        .map((v) => v.title)
        .join('，')
    }

    function getTagStyle (item: TagShow) {
      const style = { bgColor: '', color: '', icon: '', title: '' }
      if (item.type === SafetyTagType.threatType) {
        const level = (item.level ?? ThreatLevel.unknown) as ThreatLevel
        style.color = resolveThreatLevelColor(level)
        style.icon = ThreatTagIcon[ThreatLevel[level] as keyof typeof ThreatTagIcon] ?? ''
      } else if (item.type === SafetyTagType.basicInfo) {
        if (item.name.toLowerCase() === 'whitelist') {
          style.color = SafetyTagTypeColor[SafetyTagTypeReverse.basic_info]
          style.icon = SafetyTagTypeIcon[SafetyTagTypeReverse.basic_info]
        } else {
          style.color = SafetyTagTypeColor[SafetyTagTypeReverse.unknown]
          style.icon = SafetyTagTypeIcon[SafetyTagTypeReverse.unknown]
        }
      } else {
        style.color = SafetyTagTypeColor[SafetyTagTypeReverse[item.type]]
        style.icon = SafetyTagTypeIcon[SafetyTagTypeReverse[item.type]]
      }
      style.title = item.title
      style.bgColor = getOpacityColor(style.color, 0.1)
      return style
    }

    return {
      SafetyTagType,
      SafetyTagTypeReverse,
      SafetyTagTypeColor,
      SafetyTagTypeIcon,
      ThreatTagIcon,
      THREAT_TAG,
      ThreatLevelColor,
      tagSHow,
      geTooltipContent
    }
  }
})
